window.moment = require('moment');

window.moment.locale('ru');

window.Swal = require('sweetalert2/dist/sweetalert2');

require('chart.js');

import Echo from "laravel-echo"

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: true
});
